/**
 * Imperial CMS — English visitor-facing translations.
 *
 * Mirrors `pl.ts` structure (shape constrained by `MessagesShape` type).
 */

import type { MessagesShape } from "./pl";

export const messagesEn: MessagesShape = {
  maintenance: {
    title: "One moment",
    subtitle: "We're working on this section",
    body: "We'll be back shortly. The page will refresh automatically.",
    footnote: "Thank you for your patience.",
  },

  serviceDisabled: {
    title: "Site under maintenance",
    subtitle: "Service currently unavailable",
    body: "We apologize for the inconvenience. Please come back in a moment — the page will refresh automatically.",
    footnote: "Thank you for your patience.",
  },

  notFound: {
    title: "Not found",
    body: "The address you're looking for doesn't exist or has been moved.",
    homeLink: "Back to homepage",
  },

  loginRequired: {
    title: "Content available after signing in",
    body: "You must be signed in to view this page. After signing in you'll be returned right here.",
    loginButton: "Sign in",
    homeLink: "Back to homepage",
  },

  globalLoginGate: {
    title: "Sign in required",
    message: "You must sign in to access the content of this site.",
    loginLabel: "Login or e-mail",
    passwordLabel: "Password",
    submit: "Sign in",
    submitting: "Signing in...",
    failed: "Invalid login or password.",
  },

  homepage: {
    backendErrorTitle: "Backend communication error",
    redirectLoopTitle: "Homepage configuration error",
    redirectLoopMessage:
      "The homepage is currently unavailable due to a misconfigured redirect — " +
      "the specified URL points back to the homepage, creating a redirect loop.",
    redirectLoopHint: "Please contact the site administrator.",
  },

  common: {
    readDocs: "Read documentation ->",
    paginationNext: "Next ->",
  },
};
